// Strings of Try a demo account (request of 30 Oct 2026, items 4 and 5; migration 055). Arabic is new and needs
// review by an Arabic copy editor.
export const DEMO_STRINGS: Record<"en" | "ar", Record<string, string>> = {
  en: {
    demoTry: "Try a demo account",
    demoTryHint: "A temporary sample business with made-up data. No signup, mobile number or password. It is deleted after {m} minutes.",
    demoStarting: "Preparing your demo ...",
    demoBanner: "Demo account: sample data only. It ends at {t} ({left} left) and is then deleted.",
    demoExit: "Exit demo",
    demoRegister: "Create a real account",
    demoEnded: "Your demo has ended and its data has been deleted. You can start a new one.",
    demoExited: "You left the demo. Its data is being deleted.",
    demoLocked: "Locked in the demo: the demo business's information, users, permissions, packages, devices, printing and outside services cannot be changed.",
    demoNotTax: "DEMO · NOT A TAX INVOICE",
    errDemoDisabled: "The demo is not available right now.",
    errDemoFull: "All demos are in use. Try again in a few minutes.",
    errDemoRate: "Too many demos from this connection. Try again later.",
    errDemoRealSession: "You are signed in to a business in this browser. Sign out first to try the demo.",
    errDemoQuota: "This demo has reached its limit of changes. Start a new demo to continue.",
    errDemoEnded: "This demo has ended. Its data has been deleted.",
    pfNavDemo: "Demo",
    pfDemoTitle: "Public demo",
    pfDemoIntro: "Visitors on the sign-in page can start a temporary demo business with the synthetic demo data. Each visitor gets a business of their own, closed when its time is up and then deleted (its audit record stays). Demo businesses are not listed among businesses, billing or platform figures.",
    pfDemoEnabled: "Offer \"Try a demo account\" on the sign-in page",
    pfDemoOff: "Off: the sign-in page shows no demo, and starting one is refused.",
    pfDemoMinutes: "Length of a demo (minutes, 15 to 240)",
    pfDemoMaxActive: "Demos at the same time (1 to 50)",
    pfDemoPerIp: "Starts per hour from one connection (1 to 20)",
    pfDemoDaily: "Starts per day (1 to 1000)",
    pfDemoWrites: "Changes allowed in one demo (50 to 2000)",
    pfDemoTemplate: "Demo business information",
    pfDemoTemplateHint: "Shown in every new demo. Visitors cannot change it. Use made-up details only.",
    pfDemoNameEn: "Name in English", pfDemoNameAr: "Name in Arabic", pfDemoCity: "City", pfDemoStreet: "Street",
    pfDemoPhone: "Phone", pfDemoEmail: "Email", pfDemoTax: "VAT number (sample)", pfDemoCr: "Commercial registration (sample)",
    pfDemoUsage: "Usage",
    pfDemoActive: "Running now", pfDemo24h: "Started in the last 24 hours", pfDemoAwaiting: "Ended, waiting to be deleted", pfDemoPurged: "Deleted",
    pfDemoPurge: "Delete ended demos now",
    pfDemoPurged2: "{n} ended demos deleted.",
    pfDemoSaved: "Demo settings saved."
  },
  ar: {
    demoTry: "جرّب حسابًا تجريبيًا",
    demoTryHint: "منشأة نموذجية مؤقتة ببيانات تجريبية. بلا تسجيل ولا رقم جوال ولا كلمة مرور. تُحذف بعد {m} دقيقة.",
    demoStarting: "جارٍ تجهيز الحساب التجريبي ...",
    demoBanner: "حساب تجريبي: بيانات نموذجية فقط. ينتهي الساعة {t} (متبقٍ {left}) ثم يُحذف.",
    demoExit: "الخروج من التجربة",
    demoRegister: "إنشاء حساب حقيقي",
    demoEnded: "انتهت التجربة وحُذفت بياناتها. يمكنك بدء تجربة جديدة.",
    demoExited: "خرجت من التجربة. يجري حذف بياناتها.",
    demoLocked: "مقفل في التجربة: لا يمكن تغيير بيانات المنشأة التجريبية ولا المستخدمين ولا الصلاحيات ولا الباقات ولا الأجهزة ولا الطباعة ولا الخدمات الخارجية.",
    demoNotTax: "تجريبي · ليست فاتورة ضريبية",
    errDemoDisabled: "التجربة غير متاحة حاليًا.",
    errDemoFull: "كل التجارب مستخدمة الآن. حاول بعد دقائق.",
    errDemoRate: "تجارب كثيرة من هذا الاتصال. حاول لاحقًا.",
    errDemoRealSession: "أنت مسجل الدخول إلى منشأة في هذا المتصفح. سجّل الخروج أولًا لتجربة الحساب التجريبي.",
    errDemoQuota: "بلغت هذه التجربة حدها من التغييرات. ابدأ تجربة جديدة للمتابعة.",
    errDemoEnded: "انتهت هذه التجربة وحُذفت بياناتها.",
    pfNavDemo: "التجربة",
    pfDemoTitle: "الحساب التجريبي العام",
    pfDemoIntro: "يمكن لزوار صفحة الدخول بدء منشأة تجريبية مؤقتة ببيانات تجريبية. لكل زائر منشأته، تُقفل عند انتهاء وقتها ثم تُحذف (ويبقى سجل التدقيق). لا تظهر المنشآت التجريبية ضمن المنشآت ولا الفوترة ولا أرقام المنصة.",
    pfDemoEnabled: "إظهار \"جرّب حسابًا تجريبيًا\" في صفحة الدخول",
    pfDemoOff: "متوقف: لا تظهر التجربة في صفحة الدخول، ويُرفض بدؤها.",
    pfDemoMinutes: "مدة التجربة (دقائق، 15 إلى 240)",
    pfDemoMaxActive: "التجارب في الوقت نفسه (1 إلى 50)",
    pfDemoPerIp: "مرات البدء في الساعة من اتصال واحد (1 إلى 20)",
    pfDemoDaily: "مرات البدء في اليوم (1 إلى 1000)",
    pfDemoWrites: "التغييرات المسموحة في تجربة واحدة (50 إلى 2000)",
    pfDemoTemplate: "بيانات المنشأة التجريبية",
    pfDemoTemplateHint: "تظهر في كل تجربة جديدة. لا يستطيع الزوار تغييرها. استخدم بيانات وهمية فقط.",
    pfDemoNameEn: "الاسم بالإنجليزية", pfDemoNameAr: "الاسم بالعربية", pfDemoCity: "المدينة", pfDemoStreet: "الشارع",
    pfDemoPhone: "الهاتف", pfDemoEmail: "البريد الإلكتروني", pfDemoTax: "الرقم الضريبي (نموذجي)", pfDemoCr: "السجل التجاري (نموذجي)",
    pfDemoUsage: "الاستخدام",
    pfDemoActive: "قيد التشغيل الآن", pfDemo24h: "بدأت خلال 24 ساعة", pfDemoAwaiting: "انتهت وتنتظر الحذف", pfDemoPurged: "محذوفة",
    pfDemoPurge: "حذف التجارب المنتهية الآن",
    pfDemoPurged2: "حُذفت {n} تجارب منتهية.",
    pfDemoSaved: "حُفظت إعدادات التجربة."
  }
};
